import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';
import classNames from 'classnames';
import Button from 'carbon-react/lib/components/button';

import { ROUTES, getForecastByIdOnboardingUrl } from '@futrli/shared-services';

import { OnboardingPageTitle } from '../components/onboarding-page-title';
import * as styles from '../forecasting-onboarding.scss';
import { OnboardingPredictionsRouter } from '../components/onboarding-predictions-router';
import {
  BUDGET_ONBOARDING_STEP,
  LS_FORECASTING_ONBOARDING_STEP,
  SCENARIO_ONBOARDING_STEP,
  SCENARIO_WITH_INVOICES_ONBOARDING_STEP
} from '../const';
import additionalControls from '../arrows/additional-controls.png';
import { ForecastType } from './onboarding-type-select';
import { useAnimationLatency, useOnboardingUrlInfo } from '../utils/hooks';
import { usePredictionsInfoContext } from '../../detail/context/predictions-info-context';

export const OnboardingAdditionalControls = () => {
  const { workspaceId: tempWorkspaceId, organisationId: tempOrganisatioId } = useParams();
  const workspaceId = tempWorkspaceId || '';
  const organisationId = tempOrganisatioId || '';
  const { forecast } = usePredictionsInfoContext();

  const navigate = useNavigate();

  const {
    forecastType,
    isOnboardingBudgetRoute,
    isOnboardingScenarioRoute,
    isOnboardingScenarioWithInvoicesRoute
  } = useOnboardingUrlInfo();

  const showAnimatedArrow = useAnimationLatency(true);

  const handleNextClick = () => {
    if (!forecast) {
      return;
    }

    let nextStep;
    if (isOnboardingBudgetRoute) {
      nextStep =
        forecastType === ForecastType.FromScratch
          ? BUDGET_ONBOARDING_STEP.SCRATCH_READY_TO_GO
          : forecastType === ForecastType.FromLYA
          ? BUDGET_ONBOARDING_STEP.LYA_READY_TO_GO
          : BUDGET_ONBOARDING_STEP.AUTO_PREDICTIONS_READY_TO_GO;
    } else if (isOnboardingScenarioRoute) {
      nextStep =
        forecastType === ForecastType.FromScratch
          ? SCENARIO_ONBOARDING_STEP.SCRATCH_READY_TO_GO
          : forecastType === ForecastType.WithAutoPredictions
          ? SCENARIO_ONBOARDING_STEP.AUTO_PREDICTIONS_READY_TO_GO
          : SCENARIO_ONBOARDING_STEP.LYA_READY_TO_GO;
    } else {
      nextStep =
        forecastType === ForecastType.FromScratch
          ? SCENARIO_WITH_INVOICES_ONBOARDING_STEP.SCRATCH_READY_TO_GO
          : forecastType === ForecastType.WithAutoPredictions
          ? SCENARIO_WITH_INVOICES_ONBOARDING_STEP.AUTO_PREDICTIONS_READY_TO_GO
          : SCENARIO_WITH_INVOICES_ONBOARDING_STEP.LYA_READY_TO_GO;
    }

    navigate(
      `${getForecastByIdOnboardingUrl(
        workspaceId,
        organisationId,
        forecast.id,
        isOnboardingBudgetRoute,
        isOnboardingScenarioWithInvoicesRoute
      )}/${nextStep}${ROUTES.SALES}${location.search}`
    );

    localStorage.setItem(LS_FORECASTING_ONBOARDING_STEP, nextStep);
  };

  return (
    <div className={styles.contentContainer} style={{ position: 'relative' }}>
      <img
        alt="onboarding-arrow"
        src={additionalControls}
        style={{ position: 'absolute', left: 37, top: 0 }}
        className={classNames(styles.fadeInContainer, {
          [styles.fadeIn]: showAnimatedArrow
        })}
      />
      <OnboardingPageTitle
        title={
          <FormattedMessage
            id="onboarding.additional_controls"
            defaultMessage="There are additional controls here..."
          />
        }
        description={
          <FormattedMessage
            id="onboarding.including_exporting_to_google_sheets"
            defaultMessage="Including exporting to Google Sheets."
          />
        }
      />
      <Button mb="30px" buttonType="primary" size="large" onClick={handleNextClick}>
        <FormattedMessage id="common.next" defaultMessage="Next" />
      </Button>
      <OnboardingPredictionsRouter />
    </div>
  );
};
